import { useQueries } from '@tanstack/react-query'
import { useAlert } from 'contexts/AlertContext'
import { useCompanies } from 'contexts/CompaniesContext'

import { HistoryDTO } from 'models/dtos'
import React from 'react'
import { currentQueryService } from 'utils/api/queries'

const useGetMongo = () => {
  const { filteringCompaniesIds } = useCompanies()
  const { displayAlert } = useAlert()

  const results = useQueries({
    queries: filteringCompaniesIds.map((entityId) => ({
      queryKey: ['useGetMongo', entityId],
      queryFn: () => {
        if (!entityId) return Promise.resolve([])
        return currentQueryService.getMongo(entityId)
      },
      retry: 0,
    })),
  })

  const isLoading = results.some((result) => result.isLoading)
  const isError = results.some((result) => result.isError)
  const isPending = results.some((result) => result.isPending)

  React.useEffect(() => {
    if (isError) {
      displayAlert("Erreur lors du chargement de l'historique des réserves", 'error')
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isError])

  const data: HistoryDTO[] =
    isError || isPending
      ? []
      : results
          .map((result) => result.data || [])
          .flat()
          .reduce<HistoryDTO[]>((acc, item) => {
            // eslint-disable-next-line no-underscore-dangle
            if (!acc.find((existing) => existing._id === item._id)) {
              acc.push(item)
            }
            return acc
          }, [])
          .sort(
            (a, b) => new Date(b.updateDateTime).getTime() - new Date(a.updateDateTime).getTime(),
          )
  return { data, isLoading, isError }
}

export { useGetMongo }
